const API_KEY = 'AIzaSyAvILslpxhpSsN8MkIJFyW4eZpnPVwhAlY';

class GoogleMapsUtils {
  getAPIKey(): string {
    return API_KEY;
  }
}

export default new GoogleMapsUtils();
